export const CALENDAR_FEATURES = {
  moduleKey: 'calendar',
  features: ['calendar.view', 'calendar.sync'] as const,
  featureMeta: {
    'calendar.view': {
      name: 'Calendar',
      translations: { name: { de: 'Kalender', en: 'Calendar', fr: 'Calendrier', it: 'Calendario' } },
    },
    'calendar.sync': {
      name: 'Calendar sync',
      translations: {
        name: {
          de: 'Kalendersynchronisierung',
          en: 'Calendar sync',
          fr: 'Synchronisation du calendrier',
          it: 'Sincronizzazione del calendario',
        },
      },
    },
  },
} as const;
